import { useState, useRef, useEffect } from 'react';
import { gsap } from 'gsap';

export default function Header() {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    if (isMenuOpen) {
      gsap.to(menuRef.current, {
        y: 0,
        opacity: 1,
        duration: 0.5,
        ease: 'power2.out',
        display: 'block',
      });
    } else {
      gsap.to(menuRef.current, {
        y: '-100%',
        opacity: 0,
        duration: 0.5,
        ease: 'power2.in',
      });
    }
  }, [isMenuOpen]);

  return (
    <>
      {/*<div className="bg-yellow-500 text-black text-center py-2 text-sm font-bold">
        AHR in Orlando 2/10/2025
      </div>*/}

      {/* Navbar */}
      <nav className="flex items-center fixed top-0 z-50 w-full justify-between px-6 py-4 bg-black text-white">
        <div className="flex items-center space-x-3">
          <a href="/">
            <img
              src="https://cdn.shopify.com/s/files/1/0649/7687/9773/files/iFLO_PRO_Logo.White_9e04ab02-f15d-451c-8d5e-260c4bf70526.png?v=1718996114"
              alt="iFLO Pro Logo"
              className="h-16"
            />
          </a>
        </div>
        <ul className="hidden md:flex space-x-6">
        <li><a href="/contact-us" className="hover:underline">Support</a></li>
          <li><a href="/about" className="hover:underline">About</a></li>
          <li><a href="/about-formula" className="hover:underline">Formula</a></li>
          <li><a href="/news" className="hover:underline">News</a></li>
          <li><a href="/signup" className="hover:underline">Become A Pro</a></li>
          <li>
            <a href="/search" className="hover:underline">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 inline-block">
                <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
              </svg>
            </a>
          </li>
          <li>
            <a href="/signin" className="hover:underline">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 inline-block">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
              </svg>
            </a>
          </li>
        </ul>
        <div className="md:hidden z-50" style={{ position: isMenuOpen ? 'fixed' : 'relative', right: isMenuOpen ? '20px' : 'auto' }}>
          <button
            className="text-white text-3xl focus:outline-none"
            onClick={() => setMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? '✕' : '☰'}
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div
        ref={menuRef}
        className="fixed z-40 top-0 mobileMenu left-0 w-full bg-black text-white overflow-hidden md:hidden"
        style={{ transform: 'translateY(-100%)', opacity: 0 }}
      >
        <ul className="flex flex-col items-center justify-center h-screen space-y-8 text-lg">
          <li><a href="/contact-us" className="hover:underline">Support</a></li>
          <li><a href="/about" className="hover:underline">About</a></li>
          <li><a href="/about-formula" className="hover:underline">Formula</a></li>
          <li><a href="/signup" className="hover:underline">Become A Pro</a></li>
          <li>
            <a href="/search" className="flex items-center hover:underline">
              <p className="mr-2">Search</p>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 inline-block">
                <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
              </svg>
            </a>
          </li>
          <li>
            <a href="/signin" className="flex items-center hover:underline">
              <p className="mr-2">Sign In</p>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 inline-block">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
              </svg>
            </a>
          </li>
        </ul>
      </div>
    </>
  );
}
